import { useEffect, useState, type ReactNode } from 'react';
import './DetailDrawer.css';

export function DetailDrawer({
  title,
  children,
}: {
  title?: string;
  children?: ReactNode;
}) {
  const [open, setOpen] = useState<boolean>(false);
  useEffect(() => {
    function onHash() {
      setOpen(window.location.hash.startsWith('#/detail'));
    }
    window.addEventListener('hashchange', onHash);
    onHash();
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (!open) return null;
  return (
    <aside className="nx-drawer" aria-label="Detail">
      <div className="nx-drawer__head">
        <h2 className="nx-drawer__title">{title ?? 'Details'}</h2>
        <button
          type="button"
          className="nx-drawer__close"
          onClick={() => (window.location.hash = '')}
          aria-label="Close detail drawer"
        >
          ×
        </button>
      </div>
      <div className="nx-drawer__body">{children}</div>
    </aside>
  );
}